export const SubGenreTranslationJP = {
  SubGenre: {
    Title: 'サブジャンル一覧',
    Headers: {
      title: 'ジャンル詳細',
      Desc: '※モバイルオーダーは、 <br /> 　日本語以外の言語を選択し、その言語が未設定の場合、<br /> 　英語が表示されます。',
    },
    Filter: {
      fair: 'フェア',
      show_all: '全て',
      show_only_with: 'ありのみ表示',
      show_none_only: 'なしのみ表示',
      name: '名称',
      delete_date: '削除データ',
      hide_del: '削除データ非表示',
      show_all_del: '削除データ含めて表示',
      show_del: '削除データのみ表示',
    },
    Button: {
      select_all: '全選択',
      cancel_all: '解除',
      reload: 'リロード',
      detail: '詳細',
      delete: '削除',
      search: '絞り込み',
      add_new: '追加',
      keep: '保存',
      restore: '復元',
    },
    Table: {
      selection: '選択',
      sub_genre_name: 'サブジャンル名',
      fair: 'フェア',
      remarks: '備考',
    },
    Form: {
      title: 'サブジャンル詳細',
      sub_genre_name: 'サブジャンル名',
      fair_setting: 'フェア設定',
      fair_banner_area: 'フェアバナーエリア',
      image: '画像',
      background: '背景',
      color: '色',
      change: '変更',
      display_name: '表示名',
      japanese: '日本語',
      english: '英語',
      simplified_chinese: '中国語(簡体字)',
      free_group_lunch: '自由组合午餐',
      chinese_traditional: '中国語(繫体字)',
      korean: '韓国語',
      vietnamese: 'ベトナム語',
      remarks: '備考',
      fair_picture: 'フェア画像',
      fair_img_ja: '日本語',
      fair_img_en: '英語',
      fair_img_vi: 'ベトナム語',
      fair_img_ko: '韓国語',
      fair_img_zh_hant: '中国語(簡体字)',
      fair_img_zh_hans: '中国語(繫体字)',
      applicable_period: '適用期間',
      start_date: '開始',
      end_date: '終了',
      tablet: 'タブレットオーダー用',
      mobile: 'モバイルオーダー用',
    },
    Validator: {
      name: 'Required name field',
      500: '500 error server',
      success: '成功',
      error: '失敗',
      delete_success: '削除しました',
      add_success: '保存しました',
      restore_success: '復元しました。',
    },
  },
  ModalSearch: {
    title: 'プレビュー',
    language: '言語：',
  },
};
